import React, { Component } from "react";

import {
  CCardBody,
  CCardFooter,
  CLink,
  CTooltip,
  CCard,
  CCol /* , CCardHeader */
} from "@coreui/react";

import URL from "../../config/api";
import RichText from "../RichText/SlateEditor/Editor";

import "./styles.css";

class Cards extends Component {
  constructor(props) {
    super(props);

    this.state = {
      docSelected: null,
      header: this.props.header,
      body: this.props.body,
      footer: this.props.footer
      // function: this.props.function,
      // legacy: false
    };
  }

  componentWillUnmount() {
    if (this.props.body.text === undefined) {
      this.setState(() => ({
        body: { text: "" }
      }));
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.header !== prevState.header ||
      nextProps.body !== prevState.body ||
      nextProps.footer !== prevState.footer
    ) {
      return {
        header: nextProps.header,
        body: nextProps.body,
        footer: nextProps.footer
      };
    }

    return null;
  }

  render() {
    return (
      <div className="card overflow-hidden">
        {this.state.header ? (
          <header className="card-header font-weight-bold">
            {this.state.header}
            {this.props.onIconClick && (
              <div className="card-header-actions">
                <CLink
                  className="card-header-action"
                  onClick={this.props.onIconClick}
                >
                  <i
                    className={`fa fa-${this.props.icon || "folder-open-o"}`}
                  ></i>
                </CLink>
                {this.props.onSecondaryIconClick && (
                  <CLink
                    className="card-header-action ml-2"
                    onClick={this.props.onSecondaryIconClick}
                  >
                    <i
                      className={`fa fa-${
                        this.props.secondaryIcon || "folder-open-o"
                      }`}
                    ></i>
                  </CLink>
                )}
                {this.props.onTerciaryIconClick && (
                  <CLink
                    className="card-header-action ml-2"
                    onClick={this.props.onTerciaryIconClick}
                  >
                    <i
                      className={`fa fa-${
                        this.props.terciaryIcon || "folder-open-o"
                      }`}
                    ></i>
                  </CLink>
                )}
              </div>
            )}
          </header>
        ) : null}
        <CCardBody>
          {this.props.body.type === 1 ? (
            <div className="row align-items-center">
              <div className="col-9">
                <h2>{this.props.body.title}</h2>
                <h6>
                  <small>{this.props.body.subtitle}</small>
                </h6>
              </div>
              <div className="col-3">
                <button
                  className="btn btn-primary"
                  type="button"
                  style={{ float: "right" }}
                >
                  {this.props.body.text_button}
                </button>
              </div>
            </div>
          ) : this.props.body.type === 2 ? (
            <div>
              {this.props.body.items?.length ? (
                this.props.body.items.map((item, index) => (
                  <div key={index} className="cards-activity-item">
                    <div className="d-flex align-items-center">
                      <div
                        className={`cards-activity-icon-container${
                          item.activity_percentage
                            ? " done"
                            : new Date(item.activity_end) < new Date()
                            ? " late"
                            : ""
                        }`}
                      >
                        <i className="fa fa-line-chart"></i>
                      </div>
                    </div>
                    <div
                      className="d-flex flex-column justify-content-center"
                      style={{ flex: 1 }}
                    >
                      <div
                        className="cards-activity-title"
                        onClick={() => this.props.function(item.allocation_id)}
                      >
                        {item.name}
                      </div>
                      <div className="d-flex">
                        <span className="small text-muted">
                          {item.activity_percentage
                            ? "Concluída"
                            : new Date(item.activity_end) < new Date()
                            ? "Atrasada"
                            : "A fazer"}
                        </span>
                        {item.activity_percentage ? (
                          <span className="small text-success ml-1">
                            ({item.activity_percentage}%)
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="d-flex justify-content-center text-muted text-center">
                  Nenhuma atividade a ser mostrada
                </div>
              )}
            </div>
          ) : this.props.body.type === 3 ? (
            <div>
              {this.props.body.items?.length ? (
                this.props.body.items.map((item, index) => (
                  <div key={index} className="cards-discussion-item">
                    <div className="d-flex align-items-center cards-discussion-avatar">
                      <div
                        className="img-fluid"
                        style={{
                          width: "100%",
                          paddingTop: "100%",
                          backgroundImage: `url("${URL.img}${
                            item.user_photo || "uploads/users/profileEmpty.jpg"
                          }")`,
                          backgroundSize: "100% 100%",
                          borderRadius: "100%"
                        }}
                      ></div>
                    </div>
                    <div
                      className="d-flex flex-column justify-content-center text-ellipsis"
                      style={{ flex: 1 }}
                    >
                      <div
                        className="cards-discussion-title text-ellipsis"
                        onClick={() => this.props.function(item.id)}
                      >
                        {item.title}
                      </div>
                      <span className="small text-muted text-ellipsis">
                        {item.description}
                      </span>
                    </div>
                  </div>
                ))
              ) : (
                <div className="d-flex justify-content-center text-muted text-center">
                  Nenhuma discussão a ser mostrada
                </div>
              )}
            </div>
          ) : this.props.body.type === 4 ? (
            <div>
              {this.props.body.items?.length ? (
                <div
                  className="row justify-content-center"
                  style={{ marginBottom: "-15px" }}
                >
                  {this.props.body.items.map((item, index) => (
                    <div
                      key={index}
                      className="col-4"
                      style={{ marginBottom: "15px" }}
                    >
                      <CTooltip content={item.user_name} placement="top">
                        <div
                          className="img-fluid"
                          style={{
                            cursor: "pointer",
                            paddingTop: "100%",
                            backgroundImage: `url("${URL.img}${
                              item.user_photo ||
                              "uploads/users/profileEmpty.jpg"
                            }")`,
                            backgroundSize: "100% 100%",
                            borderRadius: "100%"
                          }}
                          onClick={() =>
                            this.props.history.push(`/profile/${item.user_id}`)
                          }
                        ></div>
                      </CTooltip>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="d-flex justify-content-center text-muted text-center">
                  Nenhum membro a ser mostrado
                </div>
              )}
            </div>
          ) : this.props.body.type === 5 ? (
            <div>
              {this.props.body.items.length ? (
                <div
                  className="row"
                  style={{
                    marginBottom: "-0.5rem",
                    marginTop: "-0.5rem",
                    marginLeft: "-0.5rem",
                    marginRight: "-0.5rem"
                  }}
                >
                  {this.props.body.items.map((item, index) => (
                    <CCol
                      sm={6}
                      key={index}
                      style={{
                        marginBottom: "0.5rem",
                        marginTop: "0.5rem",
                        paddingLeft: "0.5rem",
                        paddingRight: "0.5rem"
                      }}
                    >
                      <CCard
                        className={`m-0 ${
                          this.state.docSelected === item.id
                            ? "doc-selected"
                            : ""
                        }`}
                        onClick={() => this.setState({ docSelected: item.id })}
                        onDoubleClick={() =>
                          this.props.openUrl(item.name, item.link)
                        }
                      >
                        <CCardBody
                          style={{ pointerEvents: "none", userSelect: "none" }}
                        >
                          <div className="text-ellipsis text-center">
                            <i className="fa fa-file text-danger mr-3"></i>
                            {item.name}
                          </div>
                        </CCardBody>
                      </CCard>
                    </CCol>
                  ))}
                </div>
              ) : (
                <div className="d-flex justify-content-center text-muted text-center">
                  Nenhum documento a ser mostrado
                </div>
              )}
            </div>
          ) : this.props.body.type === 6 ? (
            <div>
              {this.props.body.items.length ? (
                <div
                  className="row"
                  style={{
                    marginBottom: "-0.5rem",
                    marginTop: "-0.5rem",
                    marginLeft: "-0.5rem",
                    marginRight: "-0.5rem"
                  }}
                >
                  {this.props.body.items.map((item, index) => (
                    <CCol
                      sm={6}
                      key={index}
                      style={{
                        marginBottom: "0.5rem",
                        marginTop: "0.5rem",
                        paddingLeft: "0.5rem",
                        paddingRight: "0.5rem"
                      }}
                    >
                      <CCard
                        className={`m-0 ${
                          this.state.docSelected === item.id
                            ? "doc-selected"
                            : ""
                        }`}
                        onClick={() => this.setState({ docSelected: item.id })}
                        onDoubleClick={() => this.props.function(item.link)}
                      >
                        <CCardBody
                          style={{ pointerEvents: "none", userSelect: "none" }}
                        >
                          <div className="text-ellipsis text-center">
                            <i className="fa fa-video-camera mr-3"></i>
                            {item.activity_name
                              ? `Gravação de ${item.activity_name}`
                              : decodeURIComponent(
                                  item.link.split("/").splice(-1)[0]
                                )}
                          </div>
                        </CCardBody>
                      </CCard>
                    </CCol>
                  ))}
                </div>
              ) : (
                <div className="d-flex justify-content-center text-muted text-center">
                  Nenhuma gravação a ser mostrada
                </div>
              )}
            </div>
          ) : (
            <>
              {this.props.body.text !== undefined ? (
                this.props.body.text.substring(0, 1) === "[" ? (
                  <RichText
                    description={this.props.body.text}
                    editavel={false}
                  />
                ) : (
                  <div>{this.props.body.text}</div>
                )
              ) : (
                <div></div>
              )}
            </>
          )}
        </CCardBody>
        {this.state.footer ? (
          <CCardFooter style={{ justifyContent: "flex-start" }}>
            {this.state.footer}
          </CCardFooter>
        ) : null}
      </div>
    );
  }
}

export default Cards;
